import { BANNER_SITES, bannerLayout } from './bannerLayout';
import { LINK_PREVIEW_SIZE, linkPreviewLayout } from './linkPreviewLayout';
import { THUMBNAIL_SIZE, thumbnailLayout } from './thumbnailLayout';
import type { KitCard, KitCardLayout, KitCardLayoutInput } from './kitCard';

/** The size of the file of a card. */
export function kitCardSize(card: KitCard): { width: number; height: number } {
  switch (card.kind) {
    case 'banner':
      return BANNER_SITES[card.site].size;
    case 'thumbnail':
      return THUMBNAIL_SIZE;
    case 'linkPreview':
      return LINK_PREVIEW_SIZE;
    default: {
      const exhaustive: never = card;
      return exhaustive;
    }
  }
}

/**
 * The layout of one kit card (a banner, a YouTube thumbnail, a link preview): the one entry point
 * of the renderer (music24-api `KitCard`) and the Studio preview (music24-app `CardPreview`). Pure.
 */
export function kitCardLayout(input: KitCardLayoutInput): KitCardLayout {
  const { card } = input;
  switch (card.kind) {
    case 'banner':
      return bannerLayout({ ...input, card });
    case 'thumbnail':
      return thumbnailLayout({ ...input, card });
    case 'linkPreview':
      return linkPreviewLayout({ ...input, card });
    default: {
      const exhaustive: never = card;
      return exhaustive;
    }
  }
}
